module.exports = __webpack_public_path__ + "img/member03.1bbbc129.png";